import { graphql } from "react-relay";

export const AddAccountMutation = graphql`
  mutation AddAccountMutation($connections: [ID!]!, $input: AccountInput!) {
    addAccount(input: $input) {
      account
        @appendNode(connections: $connections, edgeTypeName: "AccountEdge") {
        email
        id
        key
        name
        path
        provider
        securityContext
        statusInfo {
          details {
            at
            component
            message
            status
          }
        }
      }
    }
  }
`;
